import type { IconType } from "react-icons";
import { TbUser, TbStethoscope, TbListDetails, TbShieldCheck, TbFileText } from "react-icons/tb";

// The five steps of manual invoice creation (chapter 18). Order is the order on screen.
export type CreateStepKey = "patient" | "treatment" | "services" | "check" | "preview";

export interface CreateStep {
    key: CreateStepKey;
    Icon: IconType;
}

export const CREATE_STEPS: CreateStep[] = [
    { key: "patient", Icon: TbUser },
    { key: "treatment", Icon: TbStethoscope },
    { key: "services", Icon: TbListDetails },
    { key: "check", Icon: TbShieldCheck },
    { key: "preview", Icon: TbFileText },
];

export type StepState = "done" | "current" | "upcoming";
